import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TruckAnnouncementService } from '../../core/api/truck-announcement.service';
import { TruckAnnouncementPin } from '../../shared/models/truck-announcement';
import { AppNavComponent } from '../../shared/app-nav.component';
import { BackButtonComponent } from '../../shared/back-button.component';
import { TranslatePipe } from '../../shared/translate.pipe';
import { MneDatePipe } from '../../shared/mne-date.pipe';

@Component({
  standalone: true,
  imports: [RouterLink, AppNavComponent, BackButtonComponent, TranslatePipe, MneDatePipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <app-back></app-back>
        <h1>{{ 'ta.pin' | t }}: #{{ pinId }}</h1>
      </header>
      @if (loading()) { <div class="skeleton-detail">
        <div class="skeleton-heading"></div>
        <div class="skeleton-line w-70"></div>
        <div class="skeleton-line w-55"></div>
        <div class="skeleton-line w-85"></div>
        <div class="skeleton-line w-40"></div>
      </div> }
      @if (error()) { <p class="error notice">{{ error() | t }}</p> }
      @if (item(); as p) {
        <section class="detail-card">
          <div class="detail-heading">
            <h2>{{ p.PIN || ('ta.pinFallback' | t) }}</h2>
          </div>
          <dl>
            <dt>{{ 'common.id' | t }}</dt><dd><span class="id-badge">{{ p.Id }}</span></dd>
            <dt>{{ 'ta.licencePlate' | t }}</dt><dd>{{ p.LicencePlate || '—' }}</dd>
            <dt>{{ 'wo.serviceRequest' | t }}</dt><dd>{{ p.ServiceRequest || '—' }}</dd>
            <dt>{{ 'ta.badge' | t }}</dt><dd>{{ p.PermitUserBadgeNumber || '—' }}</dd>
            <dt>{{ 'ta.announcementFrom' | t }}</dt><dd>{{ p.AnnouncementFrom | mneDate }}</dd>
            <dt>{{ 'ta.announcementTo' | t }}</dt><dd>{{ p.AnnouncementTo | mneDate }}</dd>
          </dl>
          <div class="form-actions detail-actions">
            <a class="button" [routerLink]="editLink()">{{ 'common.edit' | t }} ✎</a>
          </div>
        </section>
      }
    </main>
  `
})
export class TruckAnnouncementPinDetailPage implements OnInit {
  readonly item = signal<TruckAnnouncementPin | null>(null);
  readonly loading = signal(true);
  readonly error = signal('');
  announcementId = '';
  pinId = '';

  constructor(private readonly route: ActivatedRoute, private readonly api: TruckAnnouncementService) {}

  editLink(): string[] {
    return this.announcementId
      ? ['/truck-announcements', this.announcementId, 'pins', this.pinId, 'edit']
      : ['/truck-announcement-pins', this.pinId, 'edit'];
  }

  ngOnInit(): void {
    this.announcementId = this.route.snapshot.paramMap.get('id') ?? '';
    this.pinId = this.route.snapshot.paramMap.get('pinId') ?? '';
    if (!this.pinId) { this.error.set('ta.pinDetailLoadError'); this.loading.set(false); return; }
    this.api.getPin(this.pinId).subscribe({
      next: pin => { this.item.set(pin); this.loading.set(false); },
      error: err => { this.error.set(err?.error?.Message ?? err?.error?.message ?? 'ta.pinDetailLoadError'); this.loading.set(false); }
    });
  }
}
